import React from "react";
import Modal from "./molecules/Modal";
import Button from "./atoms/Button";

interface AlertModalProps {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
}

const AlertModal: React.FC<AlertModalProps> = ({
  open,
  title = "Alert",
  message,
  onClose,
}) => (
  <Modal open={open} onClose={onClose} title={title}>
    <p className="mb-4">{message}</p>
    <div className="flex justify-end">
      <Button onClick={onClose} type="button">
        OK
      </Button>
    </div>
  </Modal>
);

export default AlertModal;
